import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import Stack from "react-bootstrap/Stack";
import { advanceSearchCaseList } from "../../../../services/CaseInformationApi";
import useBreadcrumbs from "../../../../hooks/useBreadCrumbs";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../redux/Store";
import DataTable from "../../../../common/DataTable";
import CustomPagination from "../../../../common/Pagination";
import TableRowsPerPage from "../../../../common/TableRowsPerPage";
import { SEARCHCASE_HEADERS } from "../actions/Constant";
import Loader from "../../../../common/Loader";
import CreateNewCase from "../../Case_Information";
import { setIsSearchEditable } from "../../../../redux/slice/CaseHeaderSlice";
import moment from "moment";

const AdvanceSearchCase: React.FC = () => {
  const breadcrumbs = useBreadcrumbs();
  const loggedInUserid = useSelector((state: RootState) => state.auth.userid);
  const [filteredData, setFilteredData] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage, setItemsPerPage] = useState<number>(10);
  const [loading, setLoading] = useState<boolean>(false);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [totalRows, setTotalRows] = useState<number>(0);
  const [sortKey, setSortKey] = useState<string>(""); // Store current sort key
  const [sortDirection, setSortDirection] = useState<string>("DESC"); // Store current sort direction
  const [advancedSearchData, setAdvancedSearchData] = useState<any>(
    JSON.parse(localStorage.getItem("advancedSearchForm") || "{}")
  );
  const [open, setOpen] = useState<boolean>(false);
  const [action, setAction] = useState<string>("");
  const [selectedUserData, setSelectedUserData] = useState<any>(null);
  const dispatch = useDispatch();

  // Function to fetch data

  const advancesearchcase = async (
    pageNumber: number = currentPage,
    pageSize: number = itemsPerPage,
    sortColumn: string = sortKey,
    sortOrder: string = sortDirection
  ) => {
    setLoading(true);
    const filterParams = {
      pageNumber,
      pageSize,
      sortColumn,
      sortOrder,
      triggerById: loggedInUserid,
    };

    const params = {
      ...filterParams,
      ...advancedSearchData,
      priorityIds: advancedSearchData?.priorityIds
        ? Array.isArray(advancedSearchData.priorityIds)
          ? advancedSearchData.priorityIds.join(",")
          : advancedSearchData.priorityIds
        : undefined,
      caseReviewTypeIds: advancedSearchData?.caseReviewTypeIds
        ? Array.isArray(advancedSearchData.caseReviewTypeIds)
          ? advancedSearchData.caseReviewTypeIds.join(",")
          : advancedSearchData.caseReviewTypeIds
        : undefined,
      caseStageIds: advancedSearchData?.caseStageIds
        ? Array.isArray(advancedSearchData.caseStageIds)
          ? advancedSearchData.caseStageIds.join(",")
          : advancedSearchData.caseStageIds
        : undefined,
      injuryTypeIds: advancedSearchData?.injuryTypeIds
        ? Array.isArray(advancedSearchData.injuryTypeIds)
          ? advancedSearchData.injuryTypeIds.join(",")
          : advancedSearchData.injuryTypeIds
        : undefined,
      severityOfInjuryIds: advancedSearchData?.severityOfInjuryIds
        ? Array.isArray(advancedSearchData.severityOfInjuryIds)
          ? advancedSearchData.severityOfInjuryIds.join(",")
          : advancedSearchData.severityOfInjuryIds
        : undefined,
      clientIds: advancedSearchData?.clientIds
        ? Array.isArray(advancedSearchData.clientIds)
          ? advancedSearchData.clientIds.join(",")
          : advancedSearchData.clientIds
        : undefined,
      defenceAttorneyIds: advancedSearchData?.defenceAttorneyIds
        ? Array.isArray(advancedSearchData.defenceAttorneyIds)
          ? advancedSearchData.defenceAttorneyIds.join(",")
          : advancedSearchData.defenceAttorneyIds
        : undefined,
      insuranceIds: advancedSearchData?.insuranceIds
        ? Array.isArray(advancedSearchData.insuranceIds)
          ? advancedSearchData.insuranceIds.join(",")
          : advancedSearchData.insuranceIds
        : undefined,
      applicantAttorneyIds: advancedSearchData?.applicantAttorneyIds
        ? Array.isArray(advancedSearchData.applicantAttorneyIds)
          ? advancedSearchData.applicantAttorneyIds.join(",")
          : advancedSearchData.applicantAttorneyIds
        : undefined,
      EmployerStakeholderIds: advancedSearchData?.EmployerStakeholderIds
        ? Array.isArray(advancedSearchData.EmployerStakeholderIds)
          ? advancedSearchData.EmployerStakeholderIds.join(",")
          : advancedSearchData.EmployerStakeholderIds
        : undefined,
      appointmentStatusIds: advancedSearchData?.appointmentStatusIds
        ? Array.isArray(advancedSearchData.appointmentStatusIds)
          ? advancedSearchData.appointmentStatusIds.join(",")
          : advancedSearchData.appointmentStatusIds
        : undefined,
      medicareIds: advancedSearchData?.medicareIds
        ? Array.isArray(advancedSearchData.medicareIds)
          ? advancedSearchData.medicareIds.join(",")
          : advancedSearchData.medicareIds
        : undefined,
      qMedDoctorIds: advancedSearchData?.qMedDoctorIds
        ? Array.isArray(advancedSearchData.qMedDoctorIds)
          ? advancedSearchData.qMedDoctorIds.join(",")
          : advancedSearchData.qMedDoctorIds
        : undefined,
      appointmentCategoryIds: advancedSearchData?.appointmentCategoryIds
        ? Array.isArray(advancedSearchData.appointmentCategoryIds)
          ? advancedSearchData.appointmentCategoryIds.join(",")
          : advancedSearchData.appointmentCategoryIds
        : undefined,
      appointmentTypeIds: advancedSearchData?.appointmentTypeIds
        ? Array.isArray(advancedSearchData.appointmentTypeIds)
          ? advancedSearchData.appointmentTypeIds.join(",")
          : advancedSearchData.appointmentTypeIds
        : undefined,
      documentTypeIds: advancedSearchData?.documentTypeIds
        ? Array.isArray(advancedSearchData.documentTypeIds)
          ? advancedSearchData.documentTypeIds.join(",")
          : advancedSearchData.documentTypeIds
        : undefined,
      documentCategoryText: advancedSearchData?.documentCategoryText
        ? Array.isArray(advancedSearchData.documentCategoryText)
          ? advancedSearchData.documentCategoryText.join(",")
          : advancedSearchData.documentCategoryText
        : undefined,
    };
    try {
      const response = await advanceSearchCaseList(params);

      if (response) {
        if (response.length > 0) {
          const formattedList = response.map((item: any) => ({
            ...item,
            dateOfExam: formattedDateTime(item.dateOfExam),
            caseSubjectDOB: formattedDateTime(item?.caseSubjectDOB),
            caseTypeDesc: item.masterClaimNumber?.startsWith("UnAssigned Claim")
              ? ""
              : item.caseTypeDesc,
            masterClaimNumber: item.masterClaimNumber?.startsWith(
              "UnAssigned Claim"
            )
              ? ""
              : item.masterClaimNumber,
          }));

          setFilteredData(formattedList);
          setTotalPages(response[0].totalPages || 1);
          setTotalRows(response[0].totalCount || 0);
        } else {
          setFilteredData([]);
          setTotalPages(1);
          setTotalRows(0);
        }
      } else {
        console.error("No data found in response");
      }
    } catch (error) {
      console.error("Error fetching case list:", error);
    } finally {
      setLoading(false);
    }
  };

  // Effect to fetch data on dependency change
  useEffect(() => {
    advancesearchcase();
  }, [currentPage, itemsPerPage, sortKey, sortDirection, advancedSearchData]);

  useEffect(() => {
    if (advancedSearchData) {
      setCurrentPage(1);
    }
  }, [advancedSearchData]);

  const formattedDateTime = (date: string | Date): string | null => {
    if (!date) {
      console.error("Invalid input: date is required.");
      return null;
    }

    const formattedDate = moment(date).format("MM/DD/YYYY");
    return `${formattedDate}`;
  };

  // Watch for changes in localStorage and update advancedSearchData
  useEffect(() => {
    let previousData = JSON.stringify(advancedSearchData);

    const interval = setInterval(() => {
      const currentData = JSON.stringify(
        JSON.parse(localStorage.getItem("advancedSearchForm") || "{}")
      );
      if (previousData !== currentData) {
        setAdvancedSearchData(JSON.parse(currentData));
        previousData = currentData;
      }
    }, 500); // Check every 500ms for changes in localStorage

    // Cleanup interval on unmount
    return () => {
      clearInterval(interval);
    };
  }, []);

  const handlePageChange = (newPage: number) => {
    setCurrentPage(newPage);
  };

  const handleRowsPerPageChange = (newItemsPerPage: number) => {
    setItemsPerPage(newItemsPerPage);
  };

  const handleRowAction = (row: any, action: string) => {
    setAction(action);
    setOpen(true);
    setSelectedUserData(row);
    dispatch(setIsSearchEditable(true));
  };

  const handleCancel = (status: string) => {
    setOpen(false);
    setCurrentPage(1);
    advancesearchcase();
    dispatch(setIsSearchEditable(false));
  };
  // useEffect(() => {
  //   if (performance.navigation.type === 1) {
  //     // 1 means the page was refreshed
  //     localStorage.removeItem("advancedSearchForm");
  //   }
  // }, []);

  useEffect(() => {
    const handleBeforeUnload = () => {
      localStorage.removeItem("advancedSearchForm");
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const handleSort = (newSortKey: { key: string; direction: string }) => {
    setSortKey(newSortKey.key);
    setSortDirection(sortDirection === "ASC" ? "DESC" : "ASC");
  };

  const entriesText = !totalRows
    ? "Showing 0 of 0 entries"
    : `Showing ${(currentPage - 1) * itemsPerPage + 1} to ${Math.min(
        currentPage * itemsPerPage,
        totalRows
      )} of ${totalRows} entries`;


  return !open ? (
    <div>
      <Loader isLoading={loading} />
      <div className="breadcrumbg">
        <Container fluid className="px-5">
          <Stack direction="horizontal" gap={2}>
            <div className="pt-0 flex-column d-flex align-items-start">
              <h4>CASE MANAGEMENT</h4>
            </div>
          </Stack>
        </Container>
      </div>
      <div>
        <div className="main_wrapper_section">
          <Container fluid className="px-5">
            <div className="sectionTitle noborder me-auto">List</div>
            <div className="adjustHeightTbAdvance">
              <DataTable
                headers={SEARCHCASE_HEADERS}
                rows={filteredData}
                onAction={handleRowAction}
                onSortAction={handleSort}
                checkInstruction={true}
              />
            </div>
            <div className="d-flex justify-content-between align-items-center mt-3">
              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-3 showingData_wrapper">
                    <span>{entriesText}</span>
                  </div>
                  <div className="col-md-9">
                    <div className="d-flex flex-row-reverse">
                      <CustomPagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                      />
                      <TableRowsPerPage
                        value={itemsPerPage}
                        onSelect={handleRowsPerPageChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </div>
      </div>
    </div>
  ) : (
    <CreateNewCase
      userData={selectedUserData}
      action={action}
      onCancel={handleCancel}
      tabState=""
    />
  );
};

export default AdvanceSearchCase;
